export default __webpack_public_path__ + "6998f60744b31400383ab73a07d2729d.otf";